import { NgModule } from '@angular/core'
import type { Routes } from '@angular/router'
import { RouterModule } from '@angular/router'

import {
  ArticleDetailsComponent,
  articleDetailsResolver,
  articleSeo,
} from '../articles/article-details/article-details.component'
import {
  AuthorDetailsComponent,
  authorDetailResolver,
  authorSeo,
} from '../authors/author-details/author-details.component'
import { EditorsOverviewComponent } from './editors-overview/editors-overview.component'

const routes: Routes = [
  { path: '', component: EditorsOverviewComponent },
  {
    path: ':id',
    component: AuthorDetailsComponent,
    resolve: { authorDetail: authorDetailResolver },
    data: { type: 'editor', seo: authorSeo },
  },
  {
    path: ':id/article/:id',
    component: ArticleDetailsComponent,
    resolve: { articleDetails: articleDetailsResolver },
    data: { seo: articleSeo },
  },
]

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class EditorsRoutingModule {}
